import { SET_AUTH_USER, SET_LOADING_SESSION } from './action-types';

export function setAuthenticatedUser(authUser) {
  return { type: SET_AUTH_USER, authUser };
}

export function setLoadingSession(loadingSession) {
  return { type: SET_LOADING_SESSION, loadingSession };
}
